import {DatabaseCode, toDatabaseCode} from "./database-code";

export type CustomFieldDefDataType = DatabaseCode;

const string: CustomFieldDefDataType = {
  code: "STRING",
  displayValue: {
    id: "common.entity.customfielddefdatatype.string",
    defaultMessage: "String",
  },
};

const number: CustomFieldDefDataType = {
  code: "NUMBER",
  displayValue: {
    id: "common.entity.customfielddefdatatype.number",
    defaultMessage: "Number",
  },
};

const boolean: CustomFieldDefDataType = {
  code: "BOOLEAN",
  displayValue: {
    id: "common.entity.customfielddefdatatype.boolean",
    defaultMessage: "Boolean",
  },
};

const temporal: CustomFieldDefDataType = {
  code: "TEMPORAL",
  displayValue: {
    id: "common.entity.customfielddefdatatype.temporal",
    defaultMessage: "Temporal",
  },
};

const ref: CustomFieldDefDataType = {
  code: "REF",
  displayValue: {
    id: "common.entity.customfielddefdatatype.ref",
    defaultMessage: "Reference",
  },
};

export const customFieldDefDataType = {
  string,
  number,
  boolean,
  temporal,
  ref,
};

export const customFieldDefDataTypes = Object.values(customFieldDefDataType);

export const toCustomFieldDefDataType = (code: string): CustomFieldDefDataType =>
  toDatabaseCode(code, customFieldDefDataTypes);

export const toCustomFieldDefDataTypeSafely = (
  code: string | undefined
): CustomFieldDefDataType | undefined =>
  code ? toDatabaseCode(code, customFieldDefDataTypes) : undefined;
